/* Packages */
import React, { useEffect, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import { useController, useFormContext } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';

/* Hooks */
import useFlowContext from "../hooks/useFlowContext";
import { useFallbackFormContext } from '../context/FallbackFormContext';

const dateDisplayFormat = "dd-MM-yyyy"
const dateBackendFormat = "yyyy-MM-dd"

export default function FlowFieldDatePicker(props) {
    const isInitialRenderRef = useRef(true);
    const {
        translate = () => {},
    } = useFlowContext();

    const { colClassName, field, path, id, updateValue } = props;
    const { type, label, required, disabled, placeholder = null, value, name, minDate, maxDate, disabledDays = [], errors } = field;

    const form = useFormContext();
    const fallbackForm = useFallbackFormContext();
    const {
        control,
    } = form || fallbackForm;

    const { field: { onChange, onBlur }, fieldState } = useController({
        control,
        name: path,
        defaultValue: value,
        rules: {
            required: {
                value: required,
                message: translate(`conversion_flow_bundle.flow.field.error.required`),
            },
        },
    });

    const error = fieldState.error?.message || errors?.[0];

    useEffect(() => {
        if (isInitialRenderRef.current) {
            isInitialRenderRef.current = false;
            return;
        }
        onChange(value);
    }, [value]);

    const resolveDateValue = (value) => {
        if (value && !(value instanceof Date)) {
            return new Date(value);
        }

        return value;
    };

    const filterDate = (date) => {
        const day = date?.getDay();
        return !disabledDays?.includes(day);
    }

    const requiredText = translate(`webstores_conversion_flow.common.required_field`);

    return (
        <div className={`${colClassName}`}>
            <Form.Group controlId={id} className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name}`}>
                {label && (
                    <Form.Label dangerouslySetInnerHTML={{ __html: label }} />
                )}
                {required === true && requiredText.length !== 0 &&
                    <span className="required-label">{requiredText}</span>
                }
                <DatePicker
                    className={`form-control ${error ? 'is-error' : ''}`}
                    selected={resolveDateValue(value)}
                    minDate={minDate ? new Date(minDate) : null}
                    maxDate={maxDate ? new Date(maxDate) : null}
                    placeholderText={placeholder}
                    id={id}
                    name={id}
                    dateFormat={dateDisplayFormat}
                    {...{
                        type,
                        required,
                        disabled,
                    }}
                    filterDate={filterDate}
                    onChange={(date) => {
                        updateValue(format(date, dateBackendFormat));
                    }}
                    onBlur={onBlur}
                />

                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
